import { styled } from 'styled-components';

export const StyledTreeSearch = styled.div`
  padding: 0 ${({ theme }) => theme.sizing.medium} 0 0;

  input {
    height: 2.375rem;
    padding: 0 0 0 ${({ theme }) => theme.sizing.xxlarge};
  }

  button {
    right: 0;
    left: 10px;
  }
`;
